interface OrbProps {
  readonly size?: number;
  /** A slow rise and fall, as when the app is waiting or listening. */
  readonly floating?: boolean;
}

/** The mark. The one gradient in the product; it does not flip with the theme. */
export function Orb({ size = 96, floating = false }: OrbProps) {
  return (
    <div
      aria-hidden
      className={`rounded-full ${floating ? "animate-orb-float" : ""}`}
      style={{
        width: size,
        height: size,
        background:
          "radial-gradient(circle at 35% 30%, var(--color-orb-inner), var(--color-orb-mid) 45%, var(--color-orb-outer))",
        boxShadow: `0 ${Math.round(size * 0.12)}px ${Math.round(size * 0.4)}px rgba(191, 211, 230, 0.35)`,
      }}
    />
  );
}
